import React, { useContext, useState } from "react"
import _ from "../../utils/lodashUtils"
import { FIREBASE_STATE_KEYS, FirebaseContext } from "../../firebase"
import { TextTag as Text } from "../../atoms"
import { Tooltip } from "antd"
import Tag from "../Tag/Tag"
import {
  COMBINED_ORDER_TOOLTIP,
  COMBINED_ORDER_LABEL,
} from "../../constants/messages"
import "./RestaurantNameHeader.scss"

const RestaurantNameHeader = (props) => {
  const [isPopOverVisible, setIsPopOverVisible] = useState(false)
  const { dateState } = useContext(FirebaseContext)
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )

  const acceptedRestaurantId =
    acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]

  let resturantName = _.get(
    props,
    `restaurants.${acceptedRestaurantId}.name`,
    ""
  )
  resturantName = resturantName
    ? resturantName
    : _.get(
        dateState,
        `${FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT}.restaurantName`,
        ""
      )

  const isOrderCombined = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.IS_ORDER_COMBINED}`,
    false
  )

  const onClickCombinedOrderTip = () => {
    isPopOverVisible ? setIsPopOverVisible(false) : setIsPopOverVisible(true)
  }
  return (
    <div className="resturant-name">
      <Text textType="sectionHeading">{resturantName}</Text>
      {isOrderCombined && (
        <div className="combined-tag">
          <Tooltip
            trigger="click"
            placement="right"
            title={COMBINED_ORDER_TOOLTIP}
            className="tag-container"
          >
            <Tag
              text={COMBINED_ORDER_LABEL}
              onClickIcon={onClickCombinedOrderTip}
              icon={true}
            />
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export default RestaurantNameHeader
